module.exports = __webpack_public_path__ + "img/entrance_plant_1@3x.84d92fd0.jpg";